// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ReadyRoundSvg from '@rsuite/icon-font/lib/status/ReadyRound';
var ReadyRound = createSvgIcon({
  as: ReadyRoundSvg,
  ariaLabel: 'ready round',
  category: 'status',
  displayName: 'ReadyRound'
});
export default ReadyRound;